const IGNORE_FILES = [".DS_Store", "Thumbs.db"];

function getFile(item) {
  return new Promise(resolve => {
    item.file(file => resolve(file));
  });
}

function getEntries(item) {
  const reader = item.createReader();
  return new Promise(resolve => {
    reader.readEntries(entries => resolve(entries));
  });
}

async function traverseDir(item, path = "") {
  const tree = [];
  if (item.isFile && !IGNORE_FILES.includes(item.name)) {
    const f = await getFile(item);
    const file = new File([f], path + item.name, { type: f.type });
    tree.push(file);
  } else if (item.isDirectory) {
    path += item.name + "/";
    const entries = await getEntries(item);
    const promises = entries.map(entry => traverseDir(entry, path));
    const list = await Promise.all(promises);
    tree.push(...list);
  }

  return tree;
}

export async function getFiles(event) {
  const source =
    event.dataTransfer ||
    event.clipboardData ||
    event.originalEvent.clipboardData;

  const entries = [];
  for (const item of source.items) {
    const entry = item.webkitGetAsEntry();
    if (entry) entries.push(entry);
  }

  const tree = [];
  for (const entry of entries) {
    const list = await traverseDir(entry);
    tree.push(...list);
  }

  return tree.flat(Infinity);
}
